export default __webpack_public_path__ + "static/media/Indexbackground.9145b880.jpg";